import { CallRounded, EmailRounded } from '@mui/icons-material'
import classNames from 'classnames'
import { TDealer } from 'feature/appeals/type'
import { formatPhoneNumber } from 'helpers/phones'
import { Link } from 'ui'
import { ModalCloseButton } from 'widget/ModalCloseButton/ModalCloseButton'

import style from './ModalDealerInformation.module.scss'

type TModalOrderManage = {
  onClose: () => void
  dealer: TDealer
}

// модальное окно с информацией о диллере

export function ModalDealerInformation({ onClose, dealer }: TModalOrderManage) {
  const formatPhone = formatPhoneNumber(dealer.phone)
  return (
    <div className={style.dealerModal}>
      <ModalCloseButton onClose={onClose} showOnMobile />
      <span className={classNames('h2', style.title)}>информация о дилере</span>
      <span className={classNames(style.dealerName, 'default-text')}>
        {dealer.name}
      </span>

      <div className={style.contactBlock}>
        <span className={style.contactItem}>
          <CallRounded color='primary' />
          <Link href={`tel:${dealer.phone}`}>{formatPhone}</Link>
        </span>
        <span className={style.contactItem}>
          <EmailRounded color='primary' />
          <Link href={`mailto:${dealer.email}`}>{dealer.email}</Link>
        </span>
      </div>
    </div>
  )
}
